export type MSpinnerBallSize = "xs" | "sm" | "md" | "lg" | "xl";

export interface MSpinnerBallProps {
  size?: MSpinnerBallSize | string | number;
  color?: string;
}

export const mSpinnerBallDefaults = {
  size: "1em",
} satisfies Partial<MSpinnerBallProps>;
